import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, ContentLoader } from '@frontend/design-system';
import { WaitlistAppointmentDetails } from './appointment-details';
import { SelectedPersonInfoHeader } from './select-person-info-header';
import { useWaitlistAppointmentDetailsForm } from './use-waitlist-appointment-details-form';

export const WaitlistAppointmentDetailsStep = () => {
  const { t } = useTranslation('schedule-quick-fill');
  const {
    timezoneAbbr,
    handleBackClick,
    handleSendMessageClick,
    form,
    isSendingInvitation,
    providerDropdownOptions,
    appointmentTypeDropdownOptions,
    activeSlotCount,
    setActiveSlotCount,
    availabilityStatus,
    isWaitlistDirectBookingEnabled,
  } = useWaitlistAppointmentDetailsForm();

  return (
    <section css={containerStyle}>
      <ContentLoader size='medium' show={isSendingInvitation} />
      <SelectedPersonInfoHeader />
      <div css={{ flex: 1, overflowY: 'auto', padding: theme.spacing(1, 0) }}>
        <WaitlistAppointmentDetails
          form={form}
          timezoneAbbr={timezoneAbbr}
          providerOptions={providerDropdownOptions}
          appointmentTypeOptions={appointmentTypeDropdownOptions}
          activeSlotCount={activeSlotCount}
          onSlotCountChange={setActiveSlotCount}
          availabilityStatus={availabilityStatus}
          isDirectBookingEnabled={isWaitlistDirectBookingEnabled}
        />
      </div>
      <footer css={footerStyle}>
        <Button variant='secondary' onClick={handleBackClick}>
          {t('Back')}
        </Button>
        <Button disabled={availabilityStatus === 'unavailable'} onClick={handleSendMessageClick}>
          {t('Send Message')}
        </Button>
      </footer>
    </section>
  );
};

const containerStyle = css({
  position: 'relative',
  height: '100%',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
});
const footerStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(1.5),
  padding: theme.spacing(3, 0),
});
